export default __webpack_public_path__ + "static/media/cart.d05720f2.svg";